"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  id: 'new',
  title: 'New Resource Center',
  pageTitle: '',
  showTitle: false,
  showTabs: true,
  description: '',
  displayOptions: {
    portal: {
      titleColor: '#02748F',
      infoBarAccentColor: '#2F8B86',
      searchBarColor: '#fff',
      backgroundColor: '#fff',
      filterHeaderColor: '#02748F',
      filterHeaderBackgroundColor: '#ddd',
      filterCollapseColor: '#2F8B86',
      filterGroupColor: '#fff',
      tabInactiveColor: '#007299',
      tabTextColor: '#fff',
      tabActiveColor: '#154988',
      resourceCountLabelColor: '#8C8C8C',
      defaultPerPageOption: 25
    },
    resources: {
      showPageControls: true,
      showThumbnail: true,
      showDescription: true,
      showTags: false,
      showShareButton: true,
      showShareIconOnly: true,
      uppercaseTitle: false,
      titleColor: '#154988',
      shareButtonColor: '#2F8B86',
      renderMode: 'list',
      coverThumbnails: false,
      showFilterGroupIcons: true,
      showSurveyPreviewMessage: false,
      hideSearchBar: false,
      hideShowingResources: false,
      hidePerPageDropdown: false,
      hideDisplayLayoutToggle: false
    }
  },
  infoBar: {
    layout: 'vertical',
    showHeader: true,
    tabs: [{
      id: 'header',
      name: 'Header Tab',
      layout: 'text',
      text: '',
      image: {
        id: 1,
        url: '',
        thumbnail: ''
      },
      config: {
        backgroundImage: true
      }
    }]
  },
  tags: [],
  tabs: [{
    id: 'tab',
    label: 'New Tab',
    tag: 'New Tab',
    icon: '',
    filterGroups: [],
    topFilterBar: {
      showTopFilterBar: false,
      tags: []
    }
  }]
};